import { mapGetters } from 'vuex';

export const upsell = {
	computed: {
		...mapGetters(['connected']),
	},
	methods: {
		maybeUpsell(event) {
			if (!this.connected) {
				event.preventDefault();
				this.$modal.show('university-promo');
			}
		},
	},
};
